<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'
import LangSwitcher from './LangSwitcher.vue'

export default {
    mixins: [messages],
    components: {
        LangSwitcher
    },
    data() {
        return {
            email: '',
            loading: false
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.loading = true
                await UserResource.forgotPassword(this.$data.email)
                this.email = ''
                this.addMessage('success', 'If there is an account attached to this email address, we\'ll send you a new login', 15000)
                this.$emit('success')
            } catch(e) {
                if (e.response && e.response.status == 400) {
                    this.addMessage('danger', 'Auth failed, please try again or contact us')
                } else {
                    this.addMessage('danger', e.message || 'An unexpected error occurred, please reload this page and try again')
                    throw e
                }
            } finally {
                this.loading = false
            }
        },
        isValidEmail() {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(this.email).toLowerCase());
        },
    }
}
</script>

<template>
    <b-form class="horizontal" @submit.prevent="onSubmit">
        <b-card class="mt-5">
            <template #header>
                <div class="d-flex align-items-center justify-content-between">
                    <span>Mot de passe oublié</span>
                    <slot name="header-action">
                        <small><lang-switcher dark /></small>
                    </slot>
                </div>
            </template>
            <b-form-group label="Adresse e-mail :">
                <b-form-input type="text" v-model="email" />
            </b-form-group>
            <div v-if="messages.length > 0">
                <b-alert :variant="message.variant" show v-for="(message, i) in messages" :key="i">{{ message.text }}</b-alert>
            </div>
            <template slot="footer">
                <b-button :to="{ name: 'login' }" variant="link" size="sm">Retour à la connexion</b-button>
                <b-button type="submit" :disabled="!isValidEmail() || loading" class="float-right">Soumettre</b-button>
            </template>
        </b-card>
    </b-form>
</template>